<script lang="ts">
  import * as Breadcrumb from "$lib/components/ui/breadcrumb/index.js";
  import { isEditActive } from "$src/application/main/mainTemplateStore";
  import { getCustomerInfo } from "$src/domain/customers/utils/customer-info-utils";
  import { useCustomer } from "$src/presentation/customers/hooks/useCustomer";

  export let groupStoreId: number;
  export let customerId: number;

  let queryCustomer = useCustomer(groupStoreId, customerId);
</script>

{#if $queryCustomer.isSuccess}
  <Breadcrumb.Separator class="hidden sm:flex" />
  <Breadcrumb.Item>
    <Breadcrumb.Link
      href={`#/gs/${groupStoreId}/customers/${customerId}`}
      asChild={$isEditActive}
    >
      {getCustomerInfo($queryCustomer.data)}
    </Breadcrumb.Link>
  </Breadcrumb.Item>
{/if}
